module.exports = __webpack_public_path__ + "img/jupiter.ee127f75.png";